import GetDigitalDonationReceiptFormDefinitionRequestModel from '../../../generated/types/model/request/GetDigitalDonationReceiptFormDefinitionRequestModel';

export default class GetDigitalDonationReceiptFormDefinitionRequestViewModel extends GetDigitalDonationReceiptFormDefinitionRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
